import React from "react";

import { Button } from "react-bootstrap";
import {
  ApproveIcon,
  CancelIcon,
  EditIcon,
  PayIcon,
  PrintIcon,
  UnApproveIcon,
} from "../gui_components/Icons.js";
import { ClipboardCopy, FileSymlink, FilePlus2,UserRound,FileSpreadsheet,HandCoins  } from "lucide-react";

export class InvoiceModuleToolBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: this.props.pageTitle,
      isShowCancelButton: this.props.isShowCancelButton,
      isShowPayButton: this.props.isShowPayButton,
      isShowApproveButton: this.props.isShowApproveButton,
      isShowUnApproveButton: this.props.isShowUnApproveButton,
    };
  }
  componentDidMount() {
    //
  }

  componentDidUpdate() {
    //
  }

  cancelInvoice = (e) => {
    if (e.detail === 1) this.props.cancelInvoice();
  };

  unApproveInvoice = (e) => {
    if (e.detail === 1) this.props.unApproveInvoice();
  };

  approveInvoice = (e) => {
    if (e.detail === 1) this.props.approveInvoice();
  };
  // modifyInvoice = () => {
  //   this.props.modifyInvoice();
  // };

  payInvoice = (e) => {
    if (e.detail === 1) this.props.payInvoice();
  };
  printNafta = (e) => {
    if (e.detail === 1) this.props.printNafta();
  };
  commInv = (e) => {
    if (e.detail === 1) this.props.commInv();
  };

  generateSalesComm = (e) => {
    if (e.detail === 1) this.props.generateSalesComm();
  };
  modifyComment = (e) => {
    if (e.detail === 1) this.props.modifyComment();
  };
  mailInvoice = (e) => {
    if (e.detail === 1) this.props.mailInvoice();
  };
  generateExcel = (e) => {
    if (e.detail === 1) this.props.generateExcel();
  };

  copyInvoice = (e) => {
    if (e.detail === 1) this.props.copyInvoice();
  };

modifyCustomer = (e) => {
    if (e.detail === 1) this.props.modifyCustomer();
  };
  render() {
    return (
      <>
        {this.props.isShowCopyInvoiceButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.copyInvoice(e)}
          >
            <ClipboardCopy size={16} />
            Copy Invoice
          </Button>
        )}
        {this.props.isShowApproveButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.approveInvoice(e)}
          >
            <ApproveIcon />
            Approve
          </Button>
        )}
        {this.props.isShowUnApproveButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.unApproveInvoice(e)}
          >
            <UnApproveIcon />
            UnApprove
          </Button>
        )}
        {this.props.isShowPayButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.payInvoice(e)}
          >
          <HandCoins size={16} />
            Pay
          </Button>
        )}
        {this.props.isShowCancelButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.cancelInvoice(e)}
          >
            <CancelIcon />
            Cancel
          </Button>
        )}

        {/*this.props.isShowModifyButton && (
          <Button
            className="header_buttons"
            size="sm"
            onClick={() => this.modifyInvoice()}
          >
            <EditIcon />
            Modify
          </Button>
        )*/}
        {this.props.isShowPrintNaftaButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.printNafta(e)}
          >
            <PrintIcon />
            PrintNafta
          </Button>
        )}
        {this.props.isShowCommInvButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.commInv(e)}
          >
            <PrintIcon />
            Comm Inv
          </Button>
        )}
        {this.props.isShowGenerateSalesCommButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.generateSalesComm(e)}
          >
            <PrintIcon />
            Generate Sales Commission
          </Button>
        )}
        {this.props.isShowModifyCommentButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.modifyComment(e)}
          >
            <EditIcon />
            ModifyComment
          </Button>
        )}
        {this.props.isShowMailInvoiceButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.mailInvoice(e)}
          >
            <EditIcon />
            Mail SaleInvoice
          </Button>
        )}
        {this.props.isShowExcelButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.generateExcel(e)}
          >
            <FileSpreadsheet size={16} />
            Excel
          </Button>
        )}
        {this.props.isShowCustomerButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.modifyCustomer(e)}
          >
            {/* <PayIcon />
            Excel */}
            <UserRound size={16} />
            Customer
          </Button>
        )}
      </>
    );
  }
}
